import { CLIENTS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import { ClientInsuranceDataProperties } from './clientInsuranceProperties';

export const ClientInsurance = {
	getInsurances: (data: ClientInsuranceDataProperties) => {
		const { clientId, insuranceId, startDate } = data;
		const query = new URLSearchParams();

		query.set('startDate', startDate);

		return FetchAPI.getJson({
			urlStr: `${CLIENTS}/${clientId}/insurances/${insuranceId}/backdate?${query.toString()}`,
		});
	},
	updateInsurance: (data: ClientInsuranceDataProperties) =>
		FetchAPI.putJson({
			urlStr: `${CLIENTS}/${data.clientId}/insurances/${data.insuranceId}/backdate`,
			data,
		}),
};
